import {root} from '../../../../store/constants';

export const alias = (userId: string) => {
    if (root.App.controller.demo) return;

    root.analytics && root.analytics.alias(userId);
};
